import { SkeletonModule } from 'primeng/skeleton';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SkeletonColumn } from '../../models/list-load-state';

/** Egy helykitöltő táblázatsor; a `columns` a valódi sor celláinak alakját írja le. */
@Component({
  selector: 'tr[appOverviewSkeletonRow]',
  standalone: true,
  imports: [SkeletonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { 'aria-hidden': 'true' },
  template: `
    @for (column of columns(); track $index) {
      <td>
        @switch (column) {
          @case ('guest') {
            <div class="flex flex-col gap-1.5">
              <p-skeleton width="9rem" height="1rem" />
              <p-skeleton width="11rem" height="0.75rem" />
              <p-skeleton width="7rem" height="0.75rem" />
            </div>
          }
          @case ('flat') {
            <div class="flex items-center gap-2">
              <p-skeleton width="3rem" height="1.25rem" borderRadius="4px" />
              <p-skeleton width="4.5rem" height="1rem" />
            </div>
          }
          @case ('icon') {
            <div class="flex justify-center">
              <p-skeleton shape="circle" size="1.5rem" />
            </div>
          }
          @case ('text') {
            <p-skeleton width="5.5rem" height="1rem" />
          }
          @case ('actions') {
            <div class="flex gap-2">
              @for (button of actionPlaceholders; track button) {
                <p-skeleton width="2.25rem" height="2rem" borderRadius="6px" />
              }
            </div>
          }
        }
      </td>
    }
  `
})
export class OverviewSkeletonRowComponent {
  readonly columns = input.required<readonly SkeletonColumn[]>();

  protected readonly actionPlaceholders = [0, 1, 2] as const;
}
